import { get } from 'lodash';
import { useFormState } from 'react-hook-form';
import { FormField, FormFieldProps } from 'ui/formField';
import {
  InlineFlex,
  MarginlessBody2Secondary,
} from 'modules/frequencyManagement/components/optimize/Optimize.styles';
import {
  FrequencyManagementSchema,
  SchemaFormKeys,
} from 'modules/frequencyManagement/contexts/FormProvider';
import { WarningFill16 } from 'ui/icons';
import { colors } from 'ui/theme';

type Props = {
  children: React.ReactNode;
  hasSavedData?: boolean;
  names: SchemaFormKeys[];
} & FormFieldProps;

export const ConnectedFormMultiField = ({
  children,
  hasSavedData = false,
  labelText,
  names = [],
  ...rest
}: Props) => {
  const { errors, dirtyFields } = useFormState<FrequencyManagementSchema>();

  const allDirtyFields = names.map((name) => {
    const foundDirtyField = get(dirtyFields, name, false);
    return foundDirtyField;
  });
  const isDirty = allDirtyFields.some((dirtyField) => dirtyField);

  const allErrors = names.map((name) => {
    const foundError = get(errors, name, { message: '' });
    return foundError;
  });
  const targetError = allErrors.find((error) => error.message !== '') || { message: '' };
  return (
    <FormField
      {...rest}
      restrictionText={
        hasSavedData &&
        isDirty && (
          <InlineFlex>
            <WarningFill16 color={colors.warning100} />
            <MarginlessBody2Secondary>
              Saving will reset the waiting period
            </MarginlessBody2Secondary>
          </InlineFlex>
        )
      }
      labelText={labelText}
      errorText={targetError?.message}
      hasError={Boolean(targetError)}
    >
      {children}
    </FormField>
  );
};
